import PageTitle from "../components/PageTitle/PageTitle";
import TechPovLayout from "../components/techPov/techPovLayout";

const TechPov = () => {
  return (
    <>
    <PageTitle
      title="Tech Pov"
      description="Stories | Advice | Inspiration for the Curious Mind"
    />
    <TechPovLayout/>
    </>


  );
};

export default TechPov;
